import styled, { css } from 'styled-components';

export const SelectorLink = styled.a`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    padding: 0 5px;
  `}
`;
